import { OPEN_DRAWER, CLOSE_DRAWER } from "../../../constant/actionTypes";

const INITIAL_STATE = {
  drawer: false,
};

const themeReducer = (state = INITIAL_STATE, { type }) => {
  switch (type) {
    case OPEN_DRAWER:
      return {
        ...state,
        drawer: true,
      };
    case CLOSE_DRAWER:
      return {
        ...state,
        drawer: false,
      };
    default:
      return state;
  }
};

export default themeReducer;
